// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2LoCI","vLegacy":"SelectSecondary_vLegacy__SIvxb","error":"SelectSecondary_error__3cr2t","disabled":"SelectSecondary_disabled__3TaGx"};